import formatDate from "../../helpers/formatDate.ts";
import useTooltip from "../../hooks/useTooltip.tsx";
import classNames from "classnames";

type UpdatedIndicatorArgs = {
  updatedAt: string;
  updatedByName?: string;
  separatorBefore?: boolean;
  separatorAfter?: boolean;
  size?: "sm" | "xs";
};

export default function UpdatedIndicator({
  updatedAt,
  updatedByName,
  separatorBefore,
  separatorAfter,
  size = "sm",
}: UpdatedIndicatorArgs) {
  const tooltipRef = useTooltip<HTMLSpanElement>();

  return (
    <>
      {separatorBefore && <span className="separator">•</span>}
      <span
        ref={tooltipRef}
        className={classNames("text-muted leading-none", {
          "text-sm": size === "sm",
          "text-xs": size === "xs",
        })}
        title={I18n.t("activity.content_edited_information", {
          content_updated_at: formatDate(
            new Date(updatedAt),
            "dd.MM.yyyy HH:mm",
          ),
          content_updated_by:
            updatedByName || I18n.t("js.memberships.profile_deleted_tooltip"),
        })}
      >
        {I18n.t("js.activity.edited")}
      </span>
      {separatorAfter && <span className="separator">•</span>}
    </>
  );
}
